import { render, staticRenderFns } from "./quarterLambdaMatch.vue?vue&type=template&id=52cf2cb8&scoped=true&"
import script from "./quarterLambdaMatch.vue?vue&type=script&lang=js&"
export * from "./quarterLambdaMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf2cb8",
  null
  
)

export default component.exports